import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';
import React from 'react';
import PropTypes from 'prop-types';
import BatchExecutionDetailsModalContentTable from './BatchExecutionDetailsModalContentTable';
import { DICTIONARY } from '../BatchExecutionDetailsModalConstants';

export const formatOptionsToText = (options) => {
  if (!options) {
    return '-';
  }

  if (!isArray(options)) {
    return options;
  }

  const groups = ['', [], []];
  const resultGroups = [];

  forEach(options, (opt) => {
    const dict = DICTIONARY[opt.name] || {};
    switch (dict.group) {
      case 0:
        groups[0] = dict[opt.value] || dict.text;
        break;
      case 1:
        groups[1].push(dict[opt.value]);
        break;
      case 2:
        groups[2].push(opt.value + dict.text);
        break;
      default:
        throw new Error('Unknown filter');
    }
  });

  forEach(groups, (group, $index) => {
    if (group.length) {
      if ($index === 1) {
        groups[$index] = `included: ${group.join(', ')}`;
      }

      if ($index === 2) {
        groups[$index] = group.join('; ');
      }

      resultGroups.push(groups[$index]);
    }
  });

  return resultGroups.join('; ');
};

function BatchExecutionDetailsModalContent(props) {
  const { filename, context, options, ...otherProps } = props;

  return (
    <div className="batch-execution-details-modal__content">
      <div className="batch-execution-details-modal__content_heading">
        <div className="batch-execution-details-modal__content_heading_item">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Query file:</label>
          <strong>{filename}</strong>
        </div>
        <div className="batch-execution-details-modal__content_heading_item">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Context:</label>
          <strong>{context}</strong>
        </div>
        <div className="batch-execution-details-modal__content_heading_item">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Options:</label>
          <strong>{formatOptionsToText(options)}</strong>
        </div>
      </div>
      <BatchExecutionDetailsModalContentTable {...otherProps} />
    </div>
  );
}

BatchExecutionDetailsModalContent.propTypes = {
  filename: PropTypes.string,
  context: PropTypes.string,
  options: PropTypes.string,
};

export default BatchExecutionDetailsModalContent;
